import config from '@/config';
import cookies from 'vue-cookies';
import service from '@/api-service';
import router from '@/router';
import { getWxCode } from '@/libs/wx-utils';


export default {
    state: {
        memberInfo: {},
        hasGetMemberInfo: false,
        loginPhone: cookies.get(config.const.KEY_LOGIN_PHONE),
        verifyTime: cookies.get(config.const.KEY_VERIFY_TIME),
        authCode: cookies.get(config.const.KEY_AUTH_CODE),
        openId: cookies.get(config.const.KEY_WX_OPEN_ID),
    },
    getters: {
        authCode(state) {
            return state.authCode && state.authCode.length > 12 ? state.authCode : void(0);
        },
        loginPhone(state) {
            return state.loginPhone || void(0);
        },
        verifyTime(state) {
            return state.verifyTime || void(0);
        },
        openId(state) {
            return state.openId || void(0);
        },
        hasGetMemberInfo(state) {
            return state.hasGetMemberInfo;
        }
    },
    mutations: {
        setMemberInfo(state, memberInfo) {
            state.memberInfo = memberInfo;
        },
        setVerifyTime(state, dateTime) {
            state.verifyTime = dateTime;
            dateTime ? cookies.set(config.const.KEY_VERIFY_TIME, dateTime, new Date(dateTime)) : cookies.remove(config.const.KEY_VERIFY_TIME);
        },
        setLoginPhone(state, loginPhone) {
            state.loginPhone = loginPhone;
            loginPhone === false ? cookies.remove(config.const.KEY_LOGIN_PHONE) : cookies.set(config.const.KEY_LOGIN_PHONE, loginPhone, '7D');
        },
        setAuthCode(state, authCode) {
            state.authCode = authCode;
            authCode === false ? cookies.remove(config.const.KEY_AUTH_CODE) : cookies.set(config.const.KEY_AUTH_CODE, authCode, '7D');
        },
        setOpenId(state, openId) {
            state.openId = openId;
            openId === false ? cookies.remove(config.const.KEY_WX_OPEN_ID) : cookies.set(config.const.KEY_WX_OPEN_ID, openId, '7D');
        }
    },
    actions: {
        sendVerifyCode({ commit }, mobile) {
            return new Promise((resolve, reject) => {
                service.sendVerifyCode({ mobile }).then((res) => {
                    let currentDate = new Date();
                    commit('setVerifyTime', currentDate.getTime() + 1000 * 60 * 1);
                    resolve();
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        loginByVerify({ rootGetters, commit }, { mobile, verifyCode }) {
            return new Promise((resolve, reject) => {
                service.loginByVerify({ mobile, verify: verifyCode }).then((res) => {
                    let authCode = res.auth_code;
                    if (rootGetters.platform == 'wx' && !rootGetters.openId) {
                        let href = `${location.protocol}//${location.host}${router.options.base}${to.fullPath}`
                        getWxCode(href).then(() => {
                            commit('setAuthCode', authCode);
                            commit('setLoginPhone', mobile);
                            resolve();
                            let currentRoute = router.currentRoute;
                            let redirect = decodeURIComponent(currentRoute.query.redirect ? currentRoute.query.redirect : '/');
                            router.replace({
                                path: redirect
                            });
                        }).catch(() => {
                            reject({errorMsg: '请先授权再登录'});
                            console.log('在微信环境中 拒绝授权了那就不给手机号登录');
                        });
                    } else {
                        commit('setAuthCode', authCode);
                        commit('setLoginPhone', mobile);
                        resolve();
                        let currentRoute = router.currentRoute;
                        let redirect = decodeURIComponent(currentRoute.query.redirect ? currentRoute.query.redirect : '/');
                        router.replace({
                            path: redirect
                        });
                    }

                }).catch((error) => {
                    reject(error);
                })
            })
        },
        logout({ state, commit }) {
            return new Promise((resolve, reject) => {
                commit('setMemberInfo', {});
                commit('setAuthCode', false);
                commit('setLoginPhone', false);
                commit('setOpenId', false);
                state.hasGetMemberInfo = false;
                resolve();
            })
        },
        getMemberInfo({ state, commit }) {
       
            return new Promise((resolve, reject) => {
                // service.getMemberInfo().then((res) => {
                //     commit('setMemberInfo', {
                //         nickName: res.member.nickname,
                //         avatar: res.member.headimgurl,
                //         mobile: res.member.mobile
                //     });
                //     state.hasGetMemberInfo = true;
                //     resolve();
                // })
                resolve();
            })
        }
    }
};